import './bannerCookies.scss';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import {
  cookiesBannerTextState,
  permissionState,
  updateCookies,
  updateCookiesAnaliticas,
} from '../../../redux/slices/permissionSlice';
import { ReactComponent as Ic_info } from 'resources/icons/Ic_Info.svg';
import { IBannerCookies } from '../../../types/interfaces';
import Button from 'components/commons/buttons/button/Button';
import SvgIcon from '../../commons/icons/SvgIcon';
import { useLazyGetTextByCodeQuery } from 'redux/services/webService';
import { updateCookiesText } from 'redux/slices/permissionSlice';
import ModalAcceptCookies from './components/modalAcceptCookies/ModalAcceptCookies';
import { useLanguage, useTranslate } from 'context/languageContext';
import { Link, useLocation } from 'react-router-dom';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';

const BannerCookies = React.memo((props: IBannerCookies) => {
  const [getTextOfBanner] = useLazyGetTextByCodeQuery();
  const cookiesText = useSelector(cookiesBannerTextState);
  const [showModal, setShowModal] = useState(false);
  const selectorPermission = useSelector(permissionState);
  const location = useLocation();
  const locale = useLanguage();

  const dispatch = useDispatch();
  const t = useTranslate();
  const pathname = location.pathname;

  function acceptCookies() {
    dispatch(updateCookiesAnaliticas(true));
    dispatch(updateCookies());
  }

  React.useEffect(() => {
    getTextOfBanner({ language: locale, code: 'BANNER_POLITICA_COOKIES' }).then(((result: any) => {
      if (result?.data) {
        dispatch(updateCookiesText(result?.data?.text ?? ''));
      } else {
        dispatch(updateCookiesText(''));
      }
    }));
  }, [locale]);

  return !selectorPermission.cookies ? (
    <>
      <div
        className='overlay-banner-cookies'
        style={
          pathname.includes(RUTAS_GENERALES_MUL2.cookiesPolicy[locale])
            ? { display: 'none' }
            : undefined
        }
      >
        <div className='banner-cookies'>
          <div className='content'>
            {showModal && <ModalAcceptCookies />}
            {!showModal && (
              <>
                <div className='body'>
                  <SvgIcon ariaLabel='Informacion' Icon={Ic_info} className='icon' />
                  <div>
                    {cookiesText ? <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(cookiesText)}} /> : t('lb_cookies_principal_body')}{' '}
                    <Link
                      style={{
                        color: '#006eb7',
                        textDecorationLine: 'underline',
                        textDecorationColor: '#006eb7',
                        textDecorationStyle: 'solid',
                      }}
                      to={`/${locale}/${RUTAS_GENERALES_MUL2.cookiesPolicy[locale]}`}
                    >
                      {t('lb_cookies_read_more')}
                    </Link>
                  </div>
                </div>
                <div className='footer'>
                  <div className='section section-left'></div>
                  <div className='section section-right'>
                    <Button
                      className='btn-options'
                      title={t('lb_button_options')}
                      onClick={() => {
                        setShowModal(true);
                      }}
                    />
                    <Button
                      className='btn-accept'
                      title={t('lb_aceptar')}
                      onClick={() => acceptCookies()}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
});
export default BannerCookies;
